<template>

  <span>
    <BaseCardContentOnly :isLoading="[getCreditControlLoading]">
      
      <template #title>
        Exclusion

        <v-spacer></v-spacer>
        <v-btn color="secondary" x-small @click="exclusionDialogOpen=true"><v-icon small>edit</v-icon></v-btn>
      </template>

      <template #content>

        <v-row>
          <BaseLabelAndInfo important>
            <template #label>Kind</template>
            <template #value>{{getCreditControl.exclusion_kind | customPlaceholder}}</template>
          </BaseLabelAndInfo>
        </v-row>

        <v-row>
          <BaseLabelAndInfo>
            <template #label>Ends On</template>
            <template #value>{{getCreditControl.exclude_end_date | formatDateWithoutTime}}</template>
          </BaseLabelAndInfo>
        </v-row>

      </template>

    </BaseCardContentOnly>

    <ExclusionDialog v-model="exclusionDialogOpen" />
  </span>

</template>

<script>

  import { mapGetters } from 'vuex';

  import ExclusionDialog from '@/components/CreditControl/ExclusionDialog';

  export default {

    components: {ExclusionDialog},

    data() {
      return {
        exclusionDialogOpen: false
      }
    },

    computed: {
      ...mapGetters('creditControl',['getCreditControl','getCreditControlLoading']),
    },

  }

</script>

<style lang="scss" scoped></style>
